import http from "../utils/http";


/***  上传图片  */
export function getPostPolicy() {
  return http({
    method: 'GET',
    url: '/common/file/open/getPostPolicy',
    params: { uploadFileType: 'IMAGE'}
  });
}
/***  TOB区域树  */
export function getTobTsysAreaTree(params) {
  return http({
    method: 'GET',
    url: '/tob/tsysArea/tree/area',
    params
  });
}
/***  商品填报列表 */
export function goodsFillList(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/list',
    data:params
  });
}
/***  商品填报删除  */
export function goodsFillDelete(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/delete',
    data: params
  });
}
/***  商品填报/编辑  */
export function goodsFillUpdate(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/update',
    data: params
  });
}
/***  商品填报详情  */
export function goodsFillDetail(params) {
  return http({
    method: 'GET',
    url: '/origin/fill/detail',
    params
  });
}
/***  供应商批量删除  */
export function goodsSupplyDelete(params) {
  return http({
    method: 'POST',
    url: '/origin/supply/delete',
    data: params
  });
}
/***  供应商列表(不分页)  */
export function supplyList(params) {
  return http({
    method: 'GET',
    url: '/origin/supply/list',
    params
  });
}
/***  供应商列表(分页)  */
export function supplyListPage(params) {
  return http({
    method: 'POST',
    url: '/origin/supply/list/page',
    data: params
  });
}
/***  供应商添加  */
export function supplyAdd(params) {
  return http({
    method: 'POST',
    url: '/origin/supply/add',
    data: params
  });
}
/***  供应商详情  */
export function supplyDetail(params) {
  return http({
    method: 'GET',
    url: '/origin/supply/detail',
    params
  });
}
/***  供应商编辑  */
export function supplyEdit(params) {
  return http({
    method: 'POST',
    url: '/origin/supply/edit',
    data: params
  });
}
/***  来源管理列表  */
export function entityList(params) {
  return http({
    method: 'POST',
    url: '/origin/source/entity/paging',
    data: params
  });
}
/***  来源管理批量删除  */
export function entityDeleteBatch(params) {
  return http({
    method: 'POST',
    url: '/origin/source/entity/delete/batch',
    data: params
  });
}
/***  来源管理添加  */
export function entityAdd(params) {
  return http({
    method: 'POST',
    url: '/origin/source/entity/add',
    data: params
  });
}
/***  来源管理编辑  */
export function entityUpdate(params) {
  return http({
    method: 'POST',
    url: '/origin/source/entity/update',
    data: params
  });
}
/***  来源管理详情  */
export function entityGet(params) {
  return http({
    method: 'GET',
    url: '/origin/source/entity/get',
    params
  });
}
/***  常用商品全列表  */
export function goodsListAll(params) {
  return http({
    method: 'POST',
    url: '/origin/goods/paging',
    data: params
  });
}
/***  常用商品批量删除  */
export function goodsDeleteBatch(params) {
  return http({
    method: 'POST',
    url: '/origin/goods/delete/batch',
    data: params
  });
}
/***  商品品类树  */
export function goodsTypeTree(params) {
  return http({
    method: 'GET',
    url: '/origin/goods/type/tree',
    params
  });
}
/***  常用商品添加  */
export function goodsAdd(params) {
  return http({
    method: 'POST',
    url: '/origin/goods/add',
    data: params
  });
}
/***  常用商品编辑  */
export function goodsUpdate(params) {
  return http({
    method: 'POST',
    url: '/origin/goods/update',
    data: params
  });
}
/***  商品填报详情分页非预包装  */
export function fillDetailDispackage(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/detail/dispackage',
    data: params
  });
}
/***  商品填报详情分页预包装  */
export function fillDetailPackage(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/detail/package',
    data: params
  });
}
/***  台账  */
export function originLedger_(params) {
  return http({
    method: 'POST',
    url: '/origin/fill/ledger',
    data: params
  });
}